module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "booksection"
  }, [_c('p', {
    staticClass: "img"
  }, [_c('a', {
    attrs: {
      "id": "page6"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p6.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page6"
    }
  }), _c('h2', {
    staticClass: "recipe-ttilea"
  }, [_c('a', {
    attrs: {
      "id": "page6"
    }
  }), _c('a', {
    attrs: {
      "id": "page7"
    }
  }, [_c('span', {
    staticClass: "col7"
  }, [_vm._v("cookies, brownies & bars")])])]), _c('a', {
    attrs: {
      "id": "page7"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "col6"
  }, [_vm._v("From chewy chocolate chip cookies to sophisticated almond-filled macaroons to fudgy brownies slathered with chocolate frosting, cookies, brownies, and bars suit any occasion. Sturdier drop cookies are ideal for filling a picnic basket or tucking into lunch boxes, while delicate, cream-filled lace cookies and macaroons are classic tea party treats. Many of the treats in this book make festive gifts for everyone on your list when nestled into holiday tins.")])]), _vm._v(" "), _c('h2', {
    staticClass: "recipe-ttile1"
  }, [_c('span', {
    staticClass: "col7"
  }, [_vm._v("types of cookies")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The most basic of styles, drop cookies are formed by simply spooning mounds of soft dough onto a baking sheet. Many all-time favorites, such as chocolate chip cookies, are part of this group. Shaped cookies, a slightly more involved type, come in many forms. They can be rolled or formed by hand, piped through a pastry bag, or extruded through a cookie press. Sturdy doughs that can be rolled out thinly, cut into shapes using cookie cutters or a knife, and baked without losing their shape are best for making rolled and cut cookies. Brownies and bars, although similar to cookies in mixing and in final texture, start as batters that are poured or spread into a pan and can be cut into perfectly-sized individual servings after they bake.")]), _vm._v(" "), _c('h2', {
    staticClass: "recipe-ttile1"
  }, [_c('span', {
    staticClass: "col7"
  }, [_vm._v("readying your supplies")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Several hours before baking, check the recipe to see if butter, cream cheese, or other ingredients need to be brought to room temperature before use. Remember to turn the oven on at least 20 minutes ahead of time so that it reaches the proper temperature by the time you’re ready to bake. Before you begin, assemble and prepare all of the equipment and ingredients needed for the recipe. This includes sifting dry ingredients, squeezing juices, grating citrus zest, chopping chocolate, and, of course, measuring everything carefully. Place the ingredients easily within reach, preferably in the order that they will be added so you can be sure that nothing has been left out of the mixture.")]), _vm._v(" "), _c('h2', {
    staticClass: "recipe-ttile1"
  }, [_c('span', {
    staticClass: "col7"
  }, [_vm._v("mixing doughs & batters")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Preparing cookie dough often begins with creaming the butter and sugar together until the color changes from soft yellow to cream. This yields a light, fluffy mixture that combines well with the remaining ingredients and helps to create a tender texture. When creaming, it is important that the butter be at room temperature; if it is too cold, it’s difficult to aerate, and if it is too warm, the mixture will be dense. An electric mixer is the most efficient tool for creaming, although it can also be done by hand with a wooden spoon.")])]), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page7"
    }
  }), _c('a', {
    attrs: {
      "id": "page8"
    }
  }, [_vm._v("Next, add eggs and flavorings such as citrus juice, extracts, spices, or melted chocolate. Cold eggs can cause the bits of butter to harden, giving the mixture a slightly curdled look. If this happens, don’t be concerned: adding the dry ingredients will return the dough to a smooth consistency. Be sure to pour in the dry ingredients slowly and mix them in at a low speed to avoid a mess on the countertop. Finally, stir in any ingredients used to stud the dough or batter with additional flavor, such as nuts, dried fruits, or chocolate chips.")])]), _c('a', {
    attrs: {
      "id": "page8"
    }
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_vm._v("If a recipe calls for separated eggs, start with eggs straight from the refrigerator—cold eggs are easier to separate. If you need to whip the whites, let them come to room temperature before beating. Be sure that no yolks get into the whites, as this will prevent them from whipping properly. Store any unused yolks for another recipe.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("To fold a light mixture (such as beaten egg whites) into a heavier mixture, begin by piling one-third of the lighter mixture on top of the heavier mixture. Using a rubber spatula held vertically, slice down through the center of the mixtures to the bottom of the bowl. Turn the spatula horizontally, so it lies on the bottom of the bowl, and pull it along the bottom and up the side of the bowl, keeping the spatula flat. Pull the spatula up and over the lighter mixture, bringing some of the heavier mixture from the bottom with it. Rotate the bowl a quarter turn and repeat the folding action. Continue the folding action, rotating the bowl each time, until no white streaks remain. Once the batter has lightened in color, fold in the rest of the lighter mixture.")]), _vm._v(" "), _c('h2', {
    staticClass: "recipe-ttile1"
  }, [_c('span', {
    staticClass: "col7"
  }, [_vm._v("monitoring your oven")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("If your oven does not seem to be heating properly, use an oven thermometer, which can be kept in the oven at all times, to check the oven’s accuracy. If the temperature is slightly off, you can adjust the temperature control knob up or down until the oven reaches the correct temperature. If there is a serious discrepancy, you should have the oven checked and recalibrated by a professional. Small pockets of higher heat, called “hot spots,” can occur in any oven. To compensate for them and ensure even baking, bake cookies and brownies on the middle rack of the oven, one sheet at a time.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Convection ovens (gas or electric) have an internal fan that helps circulate air during baking in order to produce even heat all over the oven. With a convection oven, two baking sheets of cookies can be baked evenly at the same time, but convection ovens bake more quickly than standard ovens so baking times and temperatures will need adjustment.")]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p9.jpg"
    }
  })])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page8"
    }
  }), _c('a', {
    attrs: {
      "id": "page9"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "col7"
  }, [_vm._v("BAKING TIPS")])])])]), _c('a', {
    attrs: {
      "id": "page9"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Although cookies, brownies, and bars can be simple to prepare, it is still important to keep in mind a few key things to ensure perfect results for all baked goods.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', {
    staticClass: "col7"
  }, [_vm._v("•")]), _vm._v(" Use fresh ingredients and be sure they are at the proper temperatures.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', {
    staticClass: "col7"
  }, [_vm._v("•")]), _vm._v(" Use liquid measuring cups for liquids and dry measuring cups for dry ingredients. Measuring spoons can be used for both types of ingredients.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', {
    staticClass: "col7"
  }, [_vm._v("•")]), _vm._v(" Use the “spoon and sweep” method for measuring dry ingredients: Use a spoon to fill the cup to overflowing and then level the top with a knife.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', {
    staticClass: "col7"
  }, [_vm._v("•")]), _vm._v(" When measuring sticky ingredients such as honey or molasses, oil the measuring cup or spoon first so the thick liquid will slide out easily.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', {
    staticClass: "col7"
  }, [_vm._v("•")]), _vm._v(" Keep your measuring tools well organized and clean them for reuse as you go.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', {
    staticClass: "col7"
  }, [_vm._v("•")]), _vm._v(" Stay attentive during the baking process, watching that the cookies don’t get too brown.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', {
    staticClass: "col7"
  }, [_vm._v("•")]), _vm._v(" To ensure cookies stay crisp, cool them on wire racks; this allows the air circulate evenly around the entire surface of the cookies.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', {
    staticClass: "col7"
  }, [_vm._v("•")]), _vm._v(" If you live in a high-altitudearea, check with your local agricultural extension office for information on standard baking conversions.")]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p10.jpg"
    }
  })])]), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page9"
    }
  }), _c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_vm._v("Since individual ovens vary, times given in the recipes are approximate guidelines. Therefore, it is important to check cookies, brownies, and bars often as they near the end of the recommended baking time.")])]), _c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_c('h2', {
    staticClass: "recipe-ttile1"
  }, [_c('span', {
    staticClass: "col7"
  }, [_vm._v("serving your treats")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Proper cooling and the right tools are all you need for presenting these help-yourself sweets. Stock your kitchen with a variety of spatulas for transferring cookies of all sizes from the cookie sheets, wire racks for cooling, and a sharp knife to cut finished bars and brownies into individual servings.")])]), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_vm._v("Most cookies, brownies, and bars are served at room temperature for best flavor and texture, but there are some exceptions. For example, ")]), _c('span', {
    attrs: {
      "href": "#/cap06#page72",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tangy Lemon Bars (see recipe)")]), _vm._v(" and similar treats become too soft at room temperature, so they are best served cold, straight from the refrigerator. "), _c('span', {
    attrs: {
      "href": "#/cap06#page83",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Frosted Chocolate Brownies (see recipe)")]), _vm._v(" should be stored in the refrigerator to keep the frosting in the best condition, and "), _c('span', {
    attrs: {
      "href": "#/cap06#page80",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Blueberry Cheesecake Bars (see recipe)")]), _vm._v(" must be refrigerated in order to keep them fresh.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Although cookies, brownies, or bars, simply stacked on a platter, make a beautiful presentation, some additional planning can add to their appeal. Think about complementary shapes and colors when deciding to arrange and serve an assortment of treats. Arrange bars and brownies neatly on a large plate, create appealing piles of rustic cookies, or spaciously arrange more delicate or decorative treats. Use flat platters or plates to prevent cookies from sliding around too much. For a casual barbecue or picnic, line a basket with a colorful napkin and fill it with portable cookies that won’t break. For parties, serve cookies, brownies, or bars on several small, decorative plates placed in different locations around the room. It’s a good idea to cut bars into small pieces so guests can sample different types. Plan to serve two to three cookies, brownies, or bars per person, remembering that some people will want to try several kinds.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("The best storage containers are metal tins or plastic containers that can be sealed tightly. Sticky or frosted cookies, brownies, and bars are best stored in single layers. Other cookies can be layered in the container between sheets of waxed paper. To keep baked goods in prime condition for serving, always store them in the recommended containers and at the correct temperature.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("In pretty packaging, cookies, brownies, and bars are welcome gifts for almost every occasion. Keep a selection of decorative tins on hand to line with waxed paper and fill with cookies; or fill small plastic bags about three-quarters full and tie them with ribbons and tags, or seal them with stickers. Beautiful gift boxes lined with waxed paper can hold an assortment of cookies, brownies, or bars. For more about packing and "), _c('span', {
    attrs: {
      "href": "#/cap08#page93",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("shipping baked goods, see recipe")]), _vm._v(".")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1ad5e4ce","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/cap01.vue
// module id = 69
// module chunks = 0